import PropTypes from 'prop-types';
import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

import './compact-paginator.scss';

// The pager of a toolbar strip (FIN-1281): first, previous, "page / pages", next, last — as
// wide with 300 pages as with 3, so a long list never pushes the strip onto a second line.
// It calls onPageChange like semantic's Pagination does: (event, { activePage }).
const CompactPaginator = ({ activePage, totalPages, onPageChange }) => {
  const pages = Math.max(totalPages || 0, 1);
  const page = Math.min(Math.max(activePage || 1, 1), pages);
  const go = (target) => (event) => onPageChange(event, { activePage: target });

  return (
    <Button.Group size="mini" basic className="compact-paginator">
      <Button icon title="First page" disabled={page <= 1} onClick={go(1)}><Icon name="angle double left" /></Button>
      <Button icon title="Previous page" disabled={page <= 1} onClick={go(page - 1)}><Icon name="angle left" /></Button>
      <Button disabled className="compact-paginator__page">{page} / {pages}</Button>
      <Button icon title="Next page" disabled={page >= pages} onClick={go(page + 1)}><Icon name="angle right" /></Button>
      <Button icon title="Last page" disabled={page >= pages} onClick={go(pages)}><Icon name="angle double right" /></Button>
    </Button.Group>
  );
};

CompactPaginator.propTypes = {
  activePage: PropTypes.number,
  totalPages: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
};

CompactPaginator.defaultProps = { activePage: 1, totalPages: 1 };

export default CompactPaginator;
